<mat-accordion
  class="w-full"
  [multi]="props['multi'] ?? true"
  [hideToggle]="props['hideToggle'] ?? false"
  [displayMode]="props['displayMode'] ?? 'default'"
  [togglePosition]="props['togglePosition'] ?? 'after'"
>
  @for(child of field.fieldGroup; track child) {
  <mat-expansion-panel
    *ngIf="!child.hide"
    [disabled]="child.props?.disabled"
    [expanded]="props['expanded'] ?? child.props?.['expanded'] ?? false"
  >
    <mat-expansion-panel-header>
      <mat-panel-title [style.gap.px]="10">
        <span>{{ child.props?.label ?? child.key }}</span>

        <kt-preview-selection [field]="child" [showPreview]="!child.props?.['multiple']" />
      </mat-panel-title>
      <mat-panel-description *ngIf="child.props?.description">{{ child.props!.description }}</mat-panel-description>
    </mat-expansion-panel-header>

    <!-- Render the actual Formly child field -->
    <formly-field [field]="child"></formly-field>
  </mat-expansion-panel>
  }
</mat-accordion>
